import React, { useRef } from 'react';
import {
  DrawerContent,
  DrawerCloseButton,
  DrawerBody,
  DrawerFooter,
  Flex,
  Text,
  Button,
  Box
} from "@chakra-ui/react";
import DatePicker from "react-datepicker";

export const PropertyDrawerContent = ({
  checkInDate,
  checkOutDate,
  handleCheckInChange,
  handleCheckOutChange,
  handleSearchClick,
}) => {
  const checkInRef = useRef(null);
  const checkOutRef = useRef(null);

  const dateFormat = "yyyy-MM-dd";

  const formatDateToDisplay = (date) => {
    if (!date) return "";
    // Create UTC date at midnight
    const utcDate = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0, 0, 0, 0
    ));
    return utcDate.toISOString().split('T')[0];
  };

  const handleDateChange = (date, isCheckIn) => {
    // Create UTC date at midnight
    const utcDate = new Date(Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0, 0, 0, 0
    ));
    if (isCheckIn) {
      handleCheckInChange(utcDate);
    } else {
      handleCheckOutChange(utcDate);
    }
  };

  return (
    <DrawerContent
      minH={"30vh"}
      borderTopRadius="2xl"
      maxW={{ base: "100%", md: "520px" }}
      mx="auto"
      mb={{ md: 8 }}
      borderRadius={{ md: "24px" }}
    >
      <Flex
        mx={3}
        my={4}
        alignItems={"center"}
        justifyContent={"space-between"}
      >
        <Text mr={4} fontSize={"18px"} fontWeight={800}>
          Confirm Booking Dates
        </Text>

        <DrawerCloseButton pos={"relative"} top={0} right={0} />
      </Flex>
      <DrawerBody p={3}>
        <Flex flexDirection={"column"} gap={4}>
          <Flex flexDirection={"column"}>
            <Text fontWeight={800} fontSize={"12px"} pb={"5px"}>
              Check In Date
            </Text>
            <DatePicker
              selected={checkInDate}
              onChange={(date) => handleDateChange(date, true)}
              dateFormat={dateFormat}
              minDate={new Date()}
              ref={checkInRef}
              customInput={
                <Box className="custom-datepicker" cursor="pointer" color="#d0d0d0">
                  {checkInDate
                    ? formatDateToDisplay(checkInDate)
                    : "Select check-in date"}
                </Box>
              }
            />
          </Flex>
          <Flex flexDirection={"column"}>
            <Text fontWeight={800} fontSize={"12px"} pb={"5px"}>
              Check Out Date
            </Text>
            <DatePicker
              selected={checkOutDate}
              onChange={(date) => handleDateChange(date, false)}
              dateFormat={dateFormat}
              minDate={checkInDate || new Date()}
              disabled={!checkInDate}
              ref={checkOutRef}
              customInput={
                <Box
                  className="custom-datepicker"
                  cursor={checkInDate ? "pointer" : "not-allowed"}
                  opacity={checkInDate ? 1 : 0.6}
                  color="#d0d0d0"
                >
                  {checkOutDate
                    ? formatDateToDisplay(checkOutDate)
                    : "Select check-out date"}
                </Box>
              }
            />
          </Flex>
        </Flex>
      </DrawerBody>

      <DrawerFooter p={3}>
        <Button
          onClick={handleSearchClick}
          mb={5}
          bg={"#817efc"}
          color="white"
          h="42px"
          w="full"
          variant="solid"
          borderRadius="10px"
          fontSize="14px"
        >
          Search Booking
        </Button>
      </DrawerFooter>
    </DrawerContent>
  );
}; 